// Waluty sprzedaży online dostępne w UE (kod ISO 4217 + symbol prezentacyjny).
// Państwa strefy euro współdzielą EUR, więc lista zawiera waluty unikalne.
// MUSI być spójna z definicją w aplikacji klienta (flex_menu_app/src/utils/currency.ts).
export interface CurrencyDef {
  code: string;
  symbol: string;
  label: string;
}

export const EU_CURRENCIES: CurrencyDef[] = [
  { code: "EUR", symbol: "€", label: "Euro (EUR)" },
  { code: "PLN", symbol: "zł", label: "Polski złoty (PLN)" },
  { code: "BGN", symbol: "лв", label: "Lew bułgarski (BGN)" },
  { code: "CZK", symbol: "Kč", label: "Korona czeska (CZK)" },
  { code: "DKK", symbol: "kr", label: "Korona duńska (DKK)" },
  { code: "HUF", symbol: "Ft", label: "Forint węgierski (HUF)" },
  { code: "RON", symbol: "lei", label: "Lej rumuński (RON)" },
  { code: "SEK", symbol: "kr", label: "Korona szwedzka (SEK)" },
];

// Waluty obsługiwane przez Przelewy24. Inne można wybrać (obsłuży je Stripe),
// ale P24 ich nie przyjmie — pokazujemy wtedy ostrzeżenie.
export const P24_SUPPORTED_CURRENCIES = ["PLN", "EUR", "GBP", "CZK"];

const SYMBOLS: Record<string, string> = EU_CURRENCIES.reduce(
  (acc, c) => ({ ...acc, [c.code]: c.symbol }),
  {} as Record<string, string>
);

const DEFAULT_CURRENCY = "PLN";

/** Symbol waluty (fallback: kod ISO, np. "USD"). */
export const currencySymbol = (currency?: string): string => {
  const code = (currency || DEFAULT_CURRENCY).toUpperCase();
  return SYMBOLS[code] ?? code;
};

/**
 * Formatuje kwotę zapisaną w groszach/centach (najmniejsza jednostka) na string
 * z symbolem waluty, np. formatPrice(1250, "EUR") => "12,50 €".
 */
export const formatPrice = (
  amountInMinorUnits: number,
  currency?: string
): string => {
  const value = (amountInMinorUnits / 100).toFixed(2).replace(".", ",");
  return `${value} ${currencySymbol(currency)}`;
};
